import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "/api";

const userSourceScopeService = {
  get: async (userId) =>
    (await axios.get(`${API_URL}/admin/users/${userId}/source-scope`)).data,

  set: async (userId, payload) =>
    (await axios.put(`${API_URL}/admin/users/${userId}/source-scope`, payload))
      .data,

  preview: async (scopeArray) => {
    const scope = Array.isArray(scopeArray) ? scopeArray.join(",") : "";
    const url = scope
      ? `${API_URL}/admin/users/0/source-scope/preview?scope=${encodeURIComponent(
          scope,
        )}`
      : `${API_URL}/admin/users/0/source-scope/preview`;
    return (await axios.get(url)).data;
  },

  audit: async (userId) =>
    (await axios.get(`${API_URL}/admin/users/${userId}/source-scope/audit`))
      .data,
};

export default userSourceScopeService;